__turbopack_context__.v({
  "activityItemIcon": "ActivityItemIcon-module__TyBZQG__activityItemIcon",
  "activityItemIndicator": "ActivityItemIcon-module__TyBZQG__activityItemIndicator",
  "activityItemIndicatorBlue": "ActivityItemIcon-module__TyBZQG__activityItemIndicatorBlue",
  "activityItemIndicatorGray": "ActivityItemIcon-module__TyBZQG__activityItemIndicatorGray",
  "activityItemIndicatorGreen": "ActivityItemIcon-module__TyBZQG__activityItemIndicatorGreen",
  "activityItemIndicatorOrange": "ActivityItemIcon-module__TyBZQG__activityItemIndicatorOrange",
  "activityItemIndicatorTeal": "ActivityItemIcon-module__TyBZQG__activityItemIndicatorTeal",
});
